import React, { HTMLAttributes } from 'react';
import styled from '@emotion/styled';
import { darken, lighten } from '@mui/material';

type AudioPlayerProps = HTMLAttributes<HTMLDivElement> & {
  url: string;
  stopPropagation?: boolean;
};

const AudioPlayer = ({ url, stopPropagation, className }: AudioPlayerProps) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (stopPropagation) e.stopPropagation();
  };

  return (
    <AudioContainer onClick={handleClick} className={className}>
      <audio src={url} controls />
    </AudioContainer>
  );
};

export default AudioPlayer;

const AudioContainer = styled.div`
  width: 100%;
  display: flex;
  height: 100%;
  align-items: center;
  border: ${({ theme }) => `1px solid ${theme.palette.divider}`};
  border-radius: 4px;
  box-shadow: ${({ theme }) => theme.shadows[2]};
  padding: ${({ theme }) => theme.spacing(5)};
  background-color: ${({ theme }) => (theme.palette.mode === 'dark' ? theme.palette.background.paper : darken(theme.palette.background.paper, 0.2))};

  audio {
    width: 100%;
    outline: none;
  }

  audio::-webkit-media-controls-panel {
    background-color: ${({ theme }) => lighten(theme.palette.background.paper, 0.2)};
  }

  audio::-webkit-media-controls-play-button,
  audio::-webkit-media-controls-volume-slider,
  audio::-webkit-media-controls-mute-button,
  audio::-webkit-media-controls-current-time-display,
  audio::-webkit-media-controls-time-remaining-display {
    filter: invert(100%);
    outline: none;
    box-shadow: none;
  }

  audio::-webkit-media-controls-current-time-display,
  audio::-webkit-media-controls-time-remaining-display {
    ${({ theme }) => (theme.palette.mode === 'dark' ? '' : 'filter: none;')}
  }
`;
